"use client";

import React from "react";

import { ShoppingListPageProps } from "~/bff/components/ShoppingListPage";

export type ShoppingListPagePropsExtended =
  | ({
      isStoreSelected?: boolean;
    } & ShoppingListPageProps)
  | null;

export const ShoppingListPageContext =
  React.createContext<ShoppingListPagePropsExtended>(null);
